
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param callback
 * @param time
 * @return {function(...[*]): void}
 */
var debounce = (callback, time) => {
    let interval;
    return (...args) => {
        clearTimeout(interval);
        interval = setTimeout(() => {
            interval = null;
            callback(...args);
        }, time);
    };
};

/**
 * Convert a numeric value into a currency
 * @param value
 * @return {string}
 */
var moneyFormat = (value) => {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
};

var getConvertedString = (str) => {
    let input     = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm';
    let output    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let index     = x => input.indexOf(x);
    let translate = x => index(x) > -1 ? output[index(x)] : x;
    return str.split('').map(translate).join('');
}

//--------------------------------------------------------------
// Data URL
//--------------------------------------------------------------
// /**
//  * Convert a
//  * @param dataurl
//  * @return {Blob}
//  */
// var dataURLToBlob = (dataurl) => {
//     var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
//         bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
//     while(n--){
//         u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new Blob([u8arr], {type:mime});
// };
//
// /**
//  * Convert a blob to a data url
//  * @param blob
//  * @return {Promise<unknown>}
//  */
// var blobToDataURL = (blob) => {
//     return new Promise((resolve, reject) => {
//         let reader = new FileReader();
//         reader.onerror = reject;
//         reader.onload = (e) => resolve(reader.result);
//         reader.readAsDataURL(blob);
//     })
// };
//
// var isDataURL = (s) => {
//     return isDataURL.regex.test(s);
// }
// isDataURL.regex = '^data:((?:\\w+\\/(?:(?!;).)+)?)((?:;[\\w\\W]*?[^;])*),(.+)$';

//--------------------------------------------------------------
// Object URL
//--------------------------------------------------------------

/**
 * Convert a single file
 * @param objectURL
 * @return {Promise<*>}
 */
async function objectURLToBase64(objectURL) {
    if(!isObjectURL(objectURL)) {
        throw '[soundFileToBase64] Not a valid dataURL';
    }

    let blob = await objectURLToBlob(objectURL);
    let base64 = await blobToBase64(blob);

    return base64;
};

async function objectURLToBlob(url) {
    return await fetch(url).then(r => r.blob());
}

/**
 * Convert blob to base64 string
 * @param blob
 * @return {Promise<unknown>}
 */
function blobToBase64(blob) {
    const reader = new FileReader();

    reader.readAsDataURL(blob);

    return new Promise(resolve => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
}


/**
 * Convert a base64 string to blob.
 * @param base64
 * @return {Blob}
 */
function base64ToBlob(base64) {
    // Split into two parts
    const parts = base64.split(';base64,');

    // Hold the content type
    const imageType = parts[0].split(':')[1];

    // Decode Base64 string
    const decodedData = window.atob(parts[1]);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: imageType });
}

/**
 * Convert a blob to ObjectURL.
 * @param blob
 * @return {string}
 */
function blobToObjectURL(blob) {
    return URL.createObjectURL(blob);
}

/**
 * Converts a base64 string to blob, then to objectURL.
 * @param base64
 * @return {string}
 */
function base64ToObjectURL(base64) {
    try {
        return blobToObjectURL(base64ToBlob(base64));
    } catch(e) {
        throw '[base64ToSoundFile] Not a valid base64 string';
    }
};

function isObjectURL(url)
{
    return url.indexOf('blob:') === 0;
}

export {
    debounce,
    moneyFormat,
    getConvertedString,
    // dataURLToBlob,
    // blobToDataURL,
    // isDataURL,

    // check:
    isObjectURL,

    // objectURL to string
    objectURLToBase64,
    objectURLToBlob,
    blobToBase64,

    // string to objectURL
    base64ToBlob,
    blobToObjectURL,
    base64ToObjectURL,

};
